import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    // Read synchronously from storage instead of triggering setState in useEffect
    const token = sessionStorage.getItem('accessToken');
    const activeAccountId = sessionStorage.getItem('activeAccountId');

    const isAuthenticated = Boolean(token);
    const accountSelected = Boolean(activeAccountId);

    // 1. Not logged in -> send to login
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Determine current path segment
    const pageName = location.pathname.split("/").filter(Boolean)[0];

    // 2. Prevent infinite loop: do NOT redirect if we are already on dashboard
    if (!accountSelected && pageName !== "dashboard") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;